export const RIGHT_DRAWER_NS = 'components/RightDrawer';

export const i18n = {
  en: {
    fullScreen: 'Full screen',
    exitFullScreen: 'Exit full screen',
    details: 'Details',
    bargeName: 'Barge name',
    mfmName: 'MFM name',
    startAndEndDate: 'Start & End Date',
    beginForward: 'Begin Forward',
    endForward: 'End Forward',
    beginReverse: 'Begin Reverse',
    endReverse: 'End Reverse',
    averageDensity: 'Average Density',
    aerationLimit: 'Aeration Limit',
    direction: 'Direction',
    tabs: {
      bunkeringOverview: 'Bunkering Overview',
      rawData: 'Raw Data',
      alarmLogs: 'Alarm Logs',
      transmissionLogs: 'Transmission Logs',
    },
    modals: {},
  },
};
